<ng-template #modal let-modal>
  <div class="modal-header">
    <h1 class="modal-title" id="modal-basic-title">
      {{ title }}
    </h1>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
    </button>
  </div>
  <form [formGroup]="form">
    <div class="modal-body row">
      @for (question of questions; track question) {
        <div class="form-group" [ngClass]="{'col-md-6': !question.fullsize }">
          <ls-field [question]="question" [form]="form"></ls-field>
        </div>
      }
      <ng-template [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{$implicit: form, object: $object}"></ng-template>
    </div>
    <div class="modal-footer justify-content-between justify-content-md-end">
      <app-cancel-button (click)="modal.dismiss()"></app-cancel-button>
      @for (a of actions; track a) {
        @if (checkCondition(a.condition, form)) {
          <button [type]="a.submit ? 'submit' : 'button'" [ngClass]="a.class" class="btn"
            [disabled]="form.invalid"
            (click)="doAction(a.action, form, modal)">
            @if (a.icon) {
              <fa-icon icon="{{a.icon}}"></fa-icon>&nbsp;
            }
            {{ a.label }}
            @if(a.longLabel) {
              <span class="d-none d-md-inline">{{a.longLabel}}</span>
            }
          </button>
        }
      }
    </div>
  </form>
</ng-template>
